export default "__VITE_PUBLIC_ASSET__14e3ef8a__"